import React from 'react';

const TextAreaWithLabel = ({label, id, values, ...rest}) => {
    return (<div className="mb-15 w-100 container-text">
        {label && <label className='label-component'>
            {label}
        </label>}
        <textarea id={id} name={id}
                  className="textarea"
                  value={values?.hasOwnProperty(id) ? values[id] : ""}
                  {...rest}/>
    </div>);
};

export default TextAreaWithLabel;